import React, { useEffect } from "react";

import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectBundleById, setEditId, setEditError } from "src/store/gh_market/bundlesSlice";
import { fetchBundle, updateBundle } from "src/actions/gh_market/bundlesActions";

import Form from "./_partials/_Form";

const Edit: React.FC = () => {
  const dispatch = useAppDispatch();
  const id = useAppSelector(state => state.ghMarket.bundles.editId);
  const error = useAppSelector(state => state.ghMarket.bundles.editError);
  const bundle = useAppSelector(state => selectBundleById(state, id as any));

  useEffect(() => {
    if (id) {
      dispatch(fetchBundle(id as number));
    }
  }, [id, dispatch]);

  async function handleSave(data: any) {
    const resultAction = await dispatch(updateBundle({ id: id as number, data }));

    if (updateBundle.fulfilled.match(resultAction)) {
      dispatch(setEditId(null));
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={() => dispatch(setEditId(null))}
      getContainer='.v-layout--body'
    >
      <h6 className="v-content-label">Edit Bundle</h6>
      <AlertBlock type='error' message={error} onClose={() => dispatch(setEditError(null))} />
      <Form params={bundle} onFinish={handleSave} />
    </DrawerRight>
  );
}

export default Edit;
